import emergencyBox1ContentPlugin from './emergencyBox1ContentPlugin';
import emergencyElemTitlePlugin from './emergencyElemTitlePlugin';

const emergencyBox1Plugin: any = {
  Renderer: ({ children }: any) => (
    <div
      className="emergency-box1"
      style={{
        padding: 10,
      }}
    >
      {children}
    </div>
  ),
  createInitialChildren: () => {
    return [
      [
        {
          plugin: emergencyElemTitlePlugin,
        },
      ],
      [
        {
          plugin: emergencyBox1ContentPlugin,
        },
      ],
    ];
  },

  id: 'emergency-box1-plugin',
  title: 'Box Container 1',
  // description: 'Emergency Box1 element',
  version: 1,
  // controls: {
  //   type: 'autoform',
  //   schema: {
  //     required: ['backgroundColor'],
  //     properties: {
  //       backgroundColor: { type: 'string' },
  //     },
  //   },
  // },
};

export default emergencyBox1Plugin;
